import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
import { theme } from '../../themes/theme';
export default css `
    ${componentStyles}

    :host {
        display: block;
        --btn-spacing-between: var(--sgdf-spacing-small);
    }

    /* .base {
        font-size: var(--sgdf-button-font-size-medium);
        height: calc(var(--sgdf-input-height-medium) * 0.8);
        line-height: calc(
            var(--sgdf-input-height-medium) - var(--sgdf-input-border-width) * 2
        );
        border-radius: var(--sgdf-input-border-radius-medium);
        padding: 0 var(--sgdf-spacing-small);
        --btn-spacing-between: var(--sgdf-spacing-small);
    } */

    .medium {
        ${theme.texts.cssBody('normal', 'S')};
        padding: var(--sgdf-spacing-2x-small) var(--sgdf-spacing-2x-small);
        border-radius: var(--sgdf-input-border-radius-small);
        --btn-spacing-between: var(--sgdf-spacing-2x-small);
    }

    .small {
        ${theme.texts.cssBody('normal', 'XS')};
        padding: var(--sgdf-spacing-3x-small) var(--sgdf-spacing-3x-small);
        border-radius: var(--sgdf-input-border-radius-small);
        --btn-spacing-between:  var(--sgdf-spacing-3x-small);
    }

    .container {
        display: flex;
        align-items: center;
        /* border: 1px solid; */
        line-height: 1;
        white-space: nowrap;

        color: var(--item-color);
        gap: var(--btn-spacing-between);
        background-color: var(--item-bg-color);
    }

    .removable {
        padding-right: 0;
    }

    .clickable:hover {
        cursor: pointer;
        background-color: var(--item-bg-color-hover);
    }

    .icon {
        display: flex;
    }

    .has-icon {
        padding-left: var(--sgdf-spacing-2x-small);
    }
`;
//# sourceMappingURL=badge.styles.js.map